import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-information-line"></i>
            <span>关于我们</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            关于糖心
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {aboutContent.paragraphs.map((p, idx) => (
              <p key={idx}>{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutContent.stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-4 rounded-xl bg-background-50"
              >
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}